import request from '../config/axios-config';

// The approval step the signed-in user signs, with its fallbacks; {} when they sign none.
export function getOwnStep() {
    return (
        request({
            method: 'get',
            url: '/flow/own-step'
        }))
}

// Replaces the fallbacks of the signed-in user's own step.
export function saveOwnFallbacks(userIds) {
    return (
        request({
            method: 'post',
            url: '/flow/own-step/fallbacks',
            data: {userIds: userIds}
        }))
}
